import React from 'react';
import PropTypes from 'prop-types';
import { omit } from 'ramda';

const ButtonComponent = ({ element, children, space, ...rest }) => {
  const Element = typeof element === 'string' ? element : element.type;

  const props = omit(['spaceWithin', 'buttonType', 'visible'], rest);

  return (
    <Element {...element.props} {...props} space={space ? space.toString() : undefined}>
      {children}
    </Element>
  );
};

ButtonComponent.propTypes = {
  element: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.node,
  space: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default ButtonComponent;
